/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { FormControl, FormErrorMessage, FormLabel, Input } from '@chakra-ui/react';
import DatePicker, { registerLocale, ReactDatePickerProps } from 'react-datepicker';
import { Controller } from 'react-hook-form';
import { ptBR } from 'date-fns/locale';

import 'react-datepicker/dist/react-datepicker.css';

registerLocale('pt-BR', ptBR);

interface DateInputFormProps extends Omit<ReactDatePickerProps, 'onChange'> {
  name: string | undefined | any;
  label: string | undefined;
  dateStart?: string;
  dateEnd?: string;
  selectsStart?: boolean;
  selectsEnd?: boolean;
  isRequired?: boolean;
  control: any;
  errors: any;
}

export const DateInputForm = ({
  name,
  label,
  dateStart,
  dateEnd,
  selectsStart = false,
  selectsEnd = false,
  isRequired = false,
  errors,
  control,
  ...rest
}: DateInputFormProps) => {
  return (
    <FormControl isRequired={isRequired} isInvalid={!!errors[name]} mb={5}>
      <FormLabel fontWeight="bold" mb={1} mr={3} htmlFor={name}>
        {label}
      </FormLabel>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <DatePicker
            dateFormat="dd/MM/yyyy"
            locale="pt-BR"
            selectsStart={selectsStart}
            selectsEnd={selectsEnd}
            startDate={selectsStart ? field.value : dateStart ?? null}
            endDate={selectsEnd ? field.value : dateEnd ?? null}
            minDate={new Date()}
            onChange={date => field.onChange(date)}
            selected={field.value}
            showTimeSelect={false}
            todayButton="Hoje"
            customInput={
              <Input
                isInvalid={!!errors[name]}
                boxShadow="0px 2px 4px #00000050"
                background="theme.light.bodyInput"
              />
            }
            dropdownMode="select"
            isClearable
            shouldCloseOnSelect
            showMonthDropdown
            showYearDropdown
            onKeyDown={e => {
              e.preventDefault();
            }}
            {...rest}
          />
        )}
      />
      {errors[name] && <FormErrorMessage>{errors[name]?.message}</FormErrorMessage>}
    </FormControl>
  );
};
